import { render, staticRenderFns } from "./ActivityItemBannerScroll.vue?vue&type=template&id=16e4b417&scoped=true&"
import script from "./ActivityItemBannerScroll.vue?vue&type=script&lang=js&"
export * from "./ActivityItemBannerScroll.vue?vue&type=script&lang=js&"
import style0 from "./ActivityItemBannerScroll.vue?vue&type=style&index=0&id=16e4b417&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e4b417",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VFlex,VIcon,VImg,VLayout})
